import { render } from "./ScriptMain.vue?vue&type=template&id=22e19110&scoped=true"
const script = {}

import "./../../assets/styles/scripts/main.scss?vue&type=style&index=0&id=22e19110&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e19110"]])

export default __exports__